import { Component, ContentChild, EventEmitter, Input, Output } from '@angular/core';
import { ChartReadingsEchartModalComponent } from '../chart-readings-echart-modal/chart-readings-echart-modal.component';

// A panel with a header (chart name, id, dark/light mode, export, save, close) around one
// chart. The chart itself is projected in; the Analyze Sensor Readings page owns what each
// button does. The page finds a tile's chart through `chart`, matching tiles by `tileKey`.
@Component({
  standalone: false,
  selector: 'chart-tile',
  templateUrl: './chart-tile.component.html',
  styleUrls: ['./chart-tile.component.scss']
})
export class ChartTileComponent {
  // Identifies the page's tile this panel shows.
  @Input() tileKey: number;

  @Input() name: string = '';

  // The saved favorite's id; null/undefined for an unsaved chart.
  @Input() chartId: number | null | undefined = null;

  @Input() darkBackground: boolean = false;

  // False when there is nothing to save yet (no sensors, reading types or dates selected).
  @Input() canSave: boolean = true;

  // True when the page lets this tile be dragged by its header (more than one tile is open).
  @Input() reorderable: boolean = false;

  @Output() darkToggle = new EventEmitter<void>();
  @Output() exportRequested = new EventEmitter<void>();
  @Output() saveRequested = new EventEmitter<void>();
  @Output() closeRequested = new EventEmitter<void>();

  // The projected chart, so the page can read its current options (getChartDetails)
  // and export its data.
  @ContentChild(ChartReadingsEchartModalComponent) chart: ChartReadingsEchartModalComponent;
}
